import React from "react";
import { connect, ConnectedProps } from "react-redux";
import {
  ActiveSpell,
  GeneralType,
  Spell,
  Upgrade
} from "../../../../lib/types";
import { GENERAL_TYPE, UPGRADES } from "../../../../lib/enums";
import SpellList from "./SpellList";
import SubMenu from "../../../Menu/SubMenu";
import DialogButton from "../../../Common/DialogButton";
import { icons } from "../../../../assets/images/icons";
import AvailableSpells from "./AvailableSpells";
import MagicResearch from "./MagicResearch";

const mapStateToProps = (state: any) => ({
  mana: state.governorate.resources.mana,
  spells: state.governorate.spells,
  spellsLimit: state.governorate.spellsLimit,
  spellUpgradeAvailable: state.governorate.spellUpgradeAvailable,
  magicClosed: state.governorate.magicClosed,
  magicResearch: state.governorate.magicResearch,
  autocast: state.governorate.autocast,
  mageGeneral: state.governorate.generals
    .find((g: GeneralType) => g.typeId === GENERAL_TYPE.MAGE).general,
  credits: state.governorate.player.credits,
  resetSpells: state.governorate.upgrades
    .find((u: Upgrade) => u.id === UPGRADES.ResetSpells),
});

const connector = connect(mapStateToProps);

const Magic = ({
  mana,
  spells,
  spellsLimit,
  spellUpgradeAvailable,
  magicClosed,
  magicResearch,
  autocast,
  mageGeneral,
  credits,
  resetSpells,
}: ConnectedProps<typeof connector>) => (
  <>
      <section className="boxes-group">
        <SubMenu
          tabs={[
            {
              name: "Magic",
              title: "Magic",
              icon: "magie",
              label: "Selfcast",
              active: true,
              parameters: {
                reload: false
              }
            },
            {
              name: "MagicPlanner",
              title: "Magic",
              icon: "magie",
              label: "Planner",
              active: false,
              parameters: {
                reload: true
              }
            },
            {
              name: "MagicEmperorTent",
              title: "Magic",
              icon: "magie",
              label: "Emperor Tent",
              active: false,
              parameters: {
                reload: true
              }
            }
          ]}
        />

        <h2 className="h2 h2-first">
          <span className="bordered">Available spells</span>
        </h2>
        <span className="divider"/>
        <div className="box">
          <div className={"text-info"}>
            <p>Learn new spell or upgrade already known spell<br/>
              Learnt <em>{spells.learnt.length}</em> of <em>{spellsLimit}</em> spells<br/>
              <em>{spellUpgradeAvailable || 0}</em> upgrades left
            </p>
          </div>
          <AvailableSpells
            spells={spells}
            spellsLimit={spellsLimit}
            spellUpgradeAvailable={spellUpgradeAvailable}
            magicClosed={magicClosed}
          />
          <div className={"col-sm-6"}>
            <span style={{ paddingRight: "5px" }}>Reset spells</span>
            <DialogButton
              dialogOptions={{
                name: "PurchaseUpgrade",
                header: "Reset spells",
                id: UPGRADES.ResetSpells,
                params: {},
                question: `Reset learnt spells and spell upgrades? ${spells.cast.length
                  ? `<br />You have spell planned for this count. All planned spells will be canceled and spent mana and magic energy returned.`
                  : ""}`,
                purchasable: !(credits < resetSpells.price),
                price: resetSpells.price
              }}
            >
              GET <img src={icons.credit} alt=""/>
            </DialogButton>
          </div>
        </div>
      </section>

      <h2 className="h2">
        <span className="bordered">Magic research</span>
      </h2>
      <span className="divider"/>
      <section className="boxes-group">
        <div className="box">
          <MagicResearch magicResearch={magicResearch} />
        </div>
      </section>

      <h2 className="h2">
      <span className="bordered">
        Positive spells on me
      </span>
      </h2>
      <span className="divider"/>
      <section className="boxes-group">
        <SpellList
          mana={mana}
          availableSpells={spells.available
            .filter((spell: Spell) => spell.buff
              && (spell.generalSpell || spells.learnt.includes(spell.id)))}
          activeSpells={spells.active.filter((spell: ActiveSpell) => spell.spell.buff)}
          autocast={autocast}
          mageGeneral={mageGeneral}
          disperse={true}
        />
        <span className="divider"/>
      </section>

      <h2 className="h2">
    <span className="bordered">
    Negative spells on me    </span>
      </h2>
      <span className="divider"/>
      <section className="boxes-group">
        <SpellList
          activeSpells={spells.active.filter((spell: ActiveSpell) => spell.spell.debuff)}
          disperse={false}
        />
        <span className="divider"/>
      </section>
  </>
)

export default connector(Magic);
